import {useContext} from 'react';
import type {LocalizationContextType} from '../types';
import {LocalizationContext} from '../localizationContext';

export const useLocalization = (): LocalizationContextType => {
  return useContext(LocalizationContext);
};
